import React from "react";
import { FeatureRequestListItem, FeatureRequestState } from "interfaces/feature-request";
import styled from "styled-components";
import moment from "moment";
import Tag, { STATE_CONFIG } from "../shared/Tag";

const ShortValue = styled.div`
    font-size: 14px;
    font-weight: 400;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

const shortValueColumns = ["description", "createdAt", "updatedAt"];
const tagValueColumns = ["state"];

const columnValueFormatters = {
    createdAt: (value: string): string => (value ? moment(value).format("D.M.YYYY") : ""),
    updatedAt: (value: string): string => (value ? moment(value).format("D.M.YYYY") : ""),
    businessArea: (value: string): string[] => value.split(",").map((tag: string) => tag.trim()),
};

const getValue = (item: FeatureRequestListItem, valueType: string) => {
    const value = item[valueType as keyof FeatureRequestListItem];
    const valueFormatter = columnValueFormatters[valueType as keyof typeof columnValueFormatters];

    return value && valueFormatter ? valueFormatter(value) : value;
};

const TableRow: React.FC<{
    item: FeatureRequestListItem;
    valueType: string;
}> = ({ item, valueType }) => {
    const value = getValue(item, valueType);

    if (value && shortValueColumns.includes(valueType)) {
        return <ShortValue>{value}</ShortValue>;
    } else if (value && tagValueColumns.includes(valueType)) {
        const values = Array.isArray(value) ? value : [value];

        return (
            <>
                {values.map((tag, index) => (
                    <Tag key={index} {...STATE_CONFIG[tag as FeatureRequestState]} />
                ))}
            </>
        );
    } else if (Array.isArray(value)) {
        return (
            <div>
                {value.sort().map((val, index) => (
                    <div key={val}>
                        {val}
                        {index + 1 === value.length ? "" : ","}
                    </div>
                ))}
            </div>
        );
    }

    return <div>{value}</div>;
};

export default TableRow;
